import type { AutocompleteOption } from "@/components/LockedAutocomplete";
import { listKontaktKunden, type Geschaeftspartner } from "@/lib/kontakte";

export function kundeOptionFromGp(gp: Geschaeftspartner): AutocompleteOption<Geschaeftspartner> {
  const details = [gp.kundennummer, gp.ort].filter(Boolean).join(" · ");
  return {
    key: String(gp.id),
    label: gp.firmenname,
    description: details || undefined,
    value: gp,
  };
}

export async function loadAppKundeOptions(
  query: string,
): Promise<AutocompleteOption<Geschaeftspartner>[]> {
  const res = await listKontaktKunden({
    q: query.trim() || undefined,
    limit: 30,
  });
  return (res.items || []).map(kundeOptionFromGp);
}
